import {
  OVRecommendActionEnum,
  ComboFrequencyEnum,
} from '../../../schema-types/globalTypes';
import validateUUID from '../../../utils/validateUUID';
import {CASH_OBJ} from '../../../utils/potsFilter';
import {getFeeServerFromFormik} from '../CreateBuilder/BuilderDAInitialFees';
import {
  getPotContactId,
  updateRecsVarsProps,
  upsertBuilderHeader,
  containsSingleFrequency,
} from './builderHelpers';
import {getISODateOrUndefined} from '../../../utils/getISODate';

export const saveContribution = async (props: updateRecsVarsProps): Promise<string> => {
  const {accountId, destinationPots, values, builderDetails, contacts = []} = props;
  const {contribute, contact, urgency, urgencyReason} = values;
  if (!contribute) {
    throw Error('no contribute');
  }

  const leafPotId = contribute.destinationValues.existingPotId;
  const destinationPot = destinationPots?.find((x) => x.id === leafPotId);

  const ovrecommendId = await upsertBuilderHeader(props, {
    action: OVRecommendActionEnum.CONTRIBUTE,
    accountId: validateUUID(accountId),
    goalId: validateUUID(values.goal?.id),
    isNewPlanRequired: false,
    contactId: getPotContactId(contact),
    startDate:
      getISODateOrUndefined(contribute.contributeFrom?.start) ||
      getISODateOrUndefined(builderDetails?.startDate),
    productProviderId: destinationPot?.productProvider?.id,
    productNameId: destinationPot?.productName?.id,
    urgency,
    urgencyReason,
  });

  const isCash = contribute.contributeFrom?.id === CASH_OBJ.id;

  const contributeResult = await props.upsertBuilderContribute({
    variables: {
      ovrecommendId: validateUUID(ovrecommendId)!,
      destinationPotId: validateUUID(leafPotId)!,
      isFull: contribute.contributeFrom?.full ?? false,
      isInSpecie: contribute.contributeFrom?.inSpecie ?? false,
      isNewCashContribution: isCash,
      sourcePotId: isCash ? undefined : validateUUID(contribute.contributeFrom?.id),
      comboFrequency: contribute.comboFrequency ?? ComboFrequencyEnum.SINGLE,
      singleClientAmount: containsSingleFrequency(contribute.comboFrequency)
        ? Number(contribute.contributeFrom?.singleClientAmount) || 0
        : 0,
      recurringClientAmount:
        contribute.comboFrequency !== ComboFrequencyEnum.SINGLE
          ? Number(contribute.contributeFrom?.recurringClientAmount) || 0
          : 0,
      singleEmployerAmount: containsSingleFrequency(contribute.comboFrequency)
        ? Number(contribute.contributeFrom?.singleEmployerAmount) || 0
        : 0,
      recurringEmployerAmount:
        contribute.comboFrequency !== ComboFrequencyEnum.SINGLE
          ? Number(contribute.contributeFrom?.recurringEmployerAmount) || 0
          : 0,
      initialFeeId: validateUUID(contribute.contributeFrom?.initialFee ?? undefined),
      initialEmployerFeeId: validateUUID(
        contribute.contributeFrom?.initialEmployerFee ?? undefined
      ),
      sppInitialFee: getFeeServerFromFormik(
        values.isSppDa,
        contribute.contributeFrom?.legacyInitialFee
      ),
      sppInitialEmployerFee: getFeeServerFromFormik(
        values.isSppDa,
        contribute.contributeFrom?.legacyInitialEmployerFee
      ),
    },
  });

  if (!contributeResult.data?.upsertContribute?.ok) {
    const errors = contributeResult.data?.upsertContribute?.errors?.join('. ');
    throw Error(errors || 'Failed to save contribution');
  }

  return ovrecommendId;
};
